<app-service-map
  [accent]="'bandwidth'"
  [entries]="productsList"
  [loading]="loading"
  [popupBuilder]="buildPopup"
  [pops]="commercialPopList"
  [title]="'Bandwidth Service Map'">
</app-service-map>
